module.exports = __webpack_public_path__ + "img/menu-oa.e51b66d7.png";